export const ELEMENT_NAMES = {
	BUTTON: 'person-search__button',
	DATA_TABLE: 'person-search__data-table',
	INPUT: 'person-search__input',
	INPUT_OPTIONS: 'person-search__input--options',
	LABEL: 'person-search__label',
	LOADING: 'person-search__loading',
	MESSAGE_ERROR: 'person-search__message--error',
	MESSAGE_WARNING: 'person-search__message--warning',
	SELECTED_PERSON_CHIP: 'person-search__chip--person-selected',
};

export const CSS_CLASSES = {
	CONTAINER: 'person-search__container',
	FIT_CONTAINER: 'person-search__container--fit-content',
	INPUT_CONTAINER: 'person-search__inputs__container',
	INPUT_OPTIONS: 'person-search__inputs__options',
	INPUT_DIVIDER: 'person-search__inputs__divider',
	INVALID: 'person-search--invalid',
	WARNING: 'person-search--warning',
};

export const HEADERS = [
	{
		Value: 'Name',
		props: null,
	},
	{
		Value: 'Network ID',
		props: null,
	},
	{
		Value: 'Job Title',
		props: null,
	},
	{
		Value: 'Department',
		props: null,
	},
];

export const TEXT_CLASSES = {
	FIRST_NAME: 'First Name',
	LAST_NAME: 'Last Name',
	MIDDLE_INITIAL: 'Middle Initial',
	NETWORK_ID: 'Network ID',
	RESULTS_NONE: 'Search returned no results.',
	RESULTS_EXCESS: 'Search returned too many results.',
	SELECTED: 'Selected Person',
};
